<template>
  <div class="font-bold filter facet text-lg">
    <div v-if="!isOpen" @click="isOpen=true"
         class="flex flex-col cursor-pointer flex-wrap w-full align-center mt-2 justify-evenly h-1/10">
      <div class="burger p-1 flex items-center self-center justify-center">
        <img src="../../../assets/icons/filter.svg" class="transform rotate-180"/>
      </div>
      <p class="transform -rotate-90 mt-2 flex text-right items-center justify-center">
        {{ getTranslation('filter') }}
      </p>
    </div>

    <div v-if="isOpen" class="flex flex-row-reverse pl-6 pt-4 flex-row">
      <div class="burger cursor-pointer w-1/10 flex items-center justify-center"
           @click="isOpen=false">
        <font-awesome-icon icon="angle-left"/>
      </div>
      <div class="w-9/10 pb-8">
        <div class="grid grid-cols-2 gap-2">
          <p class="text-left">{{ getTranslation("decorName") }}</p>
          <c-input :idkey="0" v-model="queryData.query.decorName"
                   :name="getTranslation('decorName')"></c-input>

          <p class="text-left">{{ getTranslation("decorNumber") }}</p>
          <c-input :idkey="0" v-model="queryData.query.decorNumber"
                   :name="getTranslation('decorNumber')"></c-input>
        </div>

        <c-facet-dropdown :mode="'double'" :facets="facets.categories"
                          :title="getTranslation('categories')"/>
        <c-facet-dropdown :mode="'single'" :facets="facets.decorTypes"
                          :title="getTranslation('decorType')"/>
        <c-facet-dropdown :mode="'double'" :facets="facets.materials"
                          :title="getTranslation('material')"/>
        <c-facet-dropdown :mode="'double'" :facets="facets.plankColors"
                          :title="getTranslation('plankColor')"/>
        <c-facet-dropdown :mode="'single'" :facets="facets.plankTypes"
                          :title="getTranslation('plankType')"/>

        <div class="grid grid-rows-3">
          <div @click="onlyNewItems=!onlyNewItems"
               class="flex items-center content-center">
            <c-checkbox :selected="onlyNewItems" :mode="'large'"/>
            <label class="">{{ getTranslation('showOnlyNew') }}</label>
          </div>
          <!-- Todo: Re-enable -->
          <div @click="onlyTopItems=!onlyTopItems" v-if="false"
               class="flex items-center content-center">
            <c-checkbox :selected="onlyTopItems" :mode="'large'"/>
            <label class="">{{ getTranslation('showOnlyTop') }}</label>
          </div>
          <button @click="$emit('reload-facets')"
                  class="classen__button hover__button justify-self-end">
            <p class="leading-none">{{ getTranslation('reset') }}</p>
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import getTranslation from "../../../mixins/getTranslation";
import Button from "../../Button";
import CustomCheckbox from "../../form/CustomCheckbox";
import Input from "../../form/Input";
import DropDownFacet from "../DropDownFacet";

export default {
  name: "DecorFacets",

  mixins: [getTranslation],

  components: {
    Button,
    'c-checkbox': CustomCheckbox,
    'c-input': Input,
    'c-facet-dropdown': DropDownFacet
  },

  props: {
    facets: {required: true, type: Object},
    opened: {required: true, type: Boolean},
    onlyNew: {required: true, type: Boolean},
    onlyTop: {required: true, type: Boolean},
    queryData: {required: false}
  },

  data() {
    return {
      dropDownVisible: '',
      onlyNewItems: this.onlyNew,
      onlyTopItems: this.onlyTop,
      isOpen: this.opened,
    }
  },

  created() {

  },

  destroyed() {

  },

  computed: {},

  watch: {
    isOpen() {
      this.$emit('update:opened', this.isOpen);
    },

    onlyNewItems() {
      this.$emit('update:onlyNew', this.onlyNewItems);
    },

    onlyTopItems() {
      this.$emit('update:onlyTop', this.onlyTopItems);
    },

  },

  methods: {}
}
</script>

<style scoped>
.burger {
  height: 30px;
  width: 30px;
  color: white;
  margin-left: auto;
  margin-right: auto;
  border-radius: 50%;
  background-color: #80695A;
}

.facet {
  box-shadow: 0 0 0 2px rgba(241, 241, 241, 1);
  -webkit-box-shadow: 0 0 0 2px rgba(241, 241, 241, 1);
  -moz-box-shadow: 0 0 0 2px rgba(241, 241, 241, 1);
  border-radius: 0 0 50px 0;
}
</style>
